// Trial changes use UTC calendar days, matching the subscription service.
export function trialDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

export function shiftTrialDate(value, days) {
  const date = trialDate(value);
  if (!date || !Number.isInteger(days)) return null;
  date.setUTCDate(date.getUTCDate() + days);
  return date;
}

export function trialDateInput(value) {
  return trialDate(value)?.toISOString().slice(0, 10) || "";
}

export function parseTrialDateInput(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return null;
  const date = trialDate(value);
  return date && trialDateInput(date) === value ? date : null;
}

export function trialDaysBetween(from, to) {
  const start = trialDate(from);
  const end = trialDate(to);
  return start && end ? (end - start) / 86400000 : null;
}

export function formatTrialDate(value) {
  const date = trialDate(value);
  return date
    ? new Intl.DateTimeFormat("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
      }).format(date)
    : "Unavailable";
}

export function maxTrialReductionDays(trialEnd, today = new Date()) {
  const days = trialDaysBetween(today, trialEnd);
  return days == null ? 0 : Math.max(0, Math.min(365, days));
}
